export default "__VITE_ASSET__ee24a6c6__"